module.exports = "<h1 class=\"fs fs-bolder fs-lg fs-line-height-lg\" ng-bind=\"$ctrl.value\"></h1>";